import { ActionTypes } from './actions';
import * as signalR from "@microsoft/signalr";
import * as FingerprintJS from "@fingerprintjs/fingerprintjs"
// single signalR connection-per-page
export const connection = new signalR.HubConnectionBuilder()
  .withUrl("/defaultHub")
  .withAutomaticReconnect()
  // .configureLogging(signalR.LogLevel.Debug)
  .build();
import { Toaster } from "./toaster";
declare var OneSignal: any;
declare var gonative: any;
import { HubConnection, HubConnectionState } from '@microsoft/signalr';

$(() => {
  connection.on("Error",
    (code: number, message: string) => {
      Toaster.error(message);
    });

  connection.on("ConnectionNotAllowed",
    () => {
      window.location.href = '/connection-not-allowed';
    });

  connection.on("Info",
    (message: string) => {
      Toaster.info(message);
    });

  connection.on("OnActionCompleted",
    (actionType: ActionTypes, actionId: string, text: string) => {
      // handle Action Completed
    });

  if (connection.state === 'Disconnected') { // connection can be opened by component
    connection.start()
      .then(() => {
        console.log("connection started");
        setVisitorId();
        setOneSignalPlayerIds();
      })
      .catch((error) => {
        console.error(error.toString());
        Toaster.error("Failed to connect to server");
      });
  }

  connection.onclose((error?: Error) => {
    if (error) {
      console.error('connection was closed: ', error);
    } else {
      console.error('connection was closed');
    }
  });
});

export function setVisitorId() {
  const fpPromise = FingerprintJS.load({ /* options */ }) // https://dev.fingerprintjs.com/docs/js-agent#agent-initialization
  fpPromise
    .then(fp => fp.get())
    .then(result =>
      connection
        .invoke("SetVisitorId", result.visitorId)
        .catch((error) => console.error(error.toString())));
}

export function setOneSignalPlayerIds() {
  if (typeof OneSignal !== "undefined") {
    console.log('updating OneSignal IDs');

    OneSignal.push(function () {
      OneSignal.getUserId(function (playerId: string) {
        connection.invoke("SetOneSignalWebPushPlayerId", playerId)
          .catch((error) => console.error(error.toString()));
      });
    });

    OneSignal.push(function () {
      OneSignal.getEmailId(function (playerId: string) {
        connection.invoke("SetOneSignalEmailPlayerId", playerId)
          .catch((error) => console.error(error.toString()));
      });
    });

    OneSignal.push(function () {
      OneSignal.getSMSId(function (playerId: string) {
        connection.invoke("SetOneSignalSMSPlayerId", playerId)
          .catch((error) => console.error(error.toString()));
      });
    });

    if (typeof gonative !== "undefined") {
      gonative.onesignal.onesignalInfo().then(function (oneSignalInfo) {
        connection.invoke("SetOneSignalMobilePlayerId", JSON.stringify(oneSignalInfo))
          .catch((error) => console.error(error.toString()));
      });
    }
  }
}

export const debounce = (fn, delay = 500) => {
  let timeout: ReturnType<typeof setTimeout>;
  const currentScope = this;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(fn.bind(currentScope, ...args), delay);
  }
}